module.exports = "<navbar></navbar>\n\n<div class=\"container-fluid\">\n  <router-outlet></router-outlet>\n</div>"